import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './ProductVariation.css'; // Import the CSS file
//import { useDispatch } from 'react-redux';

function ProductVariation({ product,onEditClick }) {
   // const dispatch = useDispatch();
    const [type, setType] = useState('simple');
    const [selectedVariation, setSelectedVariation] = useState(0);
    const [variations, setVariations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    console.log("from product variation", product);

    useEffect(() => {
        // Set the product type
        setType(product.type);

        // Function to fetch variations if the product type is "variable"
        const fetchVariations = async () => {
            if (product.type === "variable") {
                setLoading(true);
                setError(null); // Reset error state
                try {
                    const response = await axios.post(
                        '/api/get_product_variants',
                        { product_id: product.product_id },
                        { withCredentials: true }
                    );
                    console.log("from api variation**", response.data.variants);
                    setVariations(response.data.variants); // Assuming the response contains the variants
                } catch (err) {
                    setError(err.message); // Handle error appropriately
                } finally {
                    setLoading(false);
                }
            } else {
                // For simple products, set variations as a single element array
                setVariations([product]);
            }
        };

        fetchVariations();
    }, [product]); // Fetch when product changes

    if (loading) {
        return <div>Loading product variations...</div>;
    }

    if (error) {
        return <div>Error fetching product variations: {error}</div>;
    }

    return (
        <div className="product-variation-container">
            
            {type === 'simple' ? (
                <div className="product-row">
                    <div className="product-column">
                        <h3>{product.name}</h3>
                        <p>Stock: <span>{product.stock}</span></p>
                        <p>Price: <span>${product.price}</span></p>
                        <p className="offer-label"> On Offer: {product.offerDetails && product.offerDetails.on_sale ? product.offerDetails.on_sale : "No"}
</p>

                        <button className="edit-btn" onClick={() => onEditClick(product)}>Edit</button>
                       
                    </div>
                </div>
            ) : (
                <>
                    {/* Dropdown for selecting a variation if "variable" */}
                    <div className="variation-selector">
                        <label htmlFor="variationOption">Select Variation:</label>
                        <select
                            id="variationOption"
                            value={selectedVariation}
                            onChange={(e) => setSelectedVariation(parseInt(e.target.value))}
                        >
                            <option value="" disabled>
                                Select Variation
                            </option>
                            {variations.map((variation, index) => (
                                <option key={variation.id} value={index}>
                                    {variation.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Display the selected variation */}
                    {variations.length > 0 && (
                        <div className="product-row">
                            <div className="product-column">
                                <h3>{variations[selectedVariation]?.name}</h3>
                                <p>Stock: <span>{variations[selectedVariation]?.stock}</span></p>
                                <p>Price: <span>${variations[selectedVariation]?.price}</span></p>
                                <p className="offer-label">
    On Offer: {variations[selectedVariation]?.offerDetails?.on_sale ? variations[selectedVariation].offerDetails.on_sale : "No"}
</p>

                                <button className="edit-btn" onClick={() => onEditClick(variations[selectedVariation])}>Edit</button>
                                
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default ProductVariation;
